import React from 'react'
import classes from './TEIDLogo.module.scss'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { teiBranding } from '@Root/tei'

const TEIDLogo = ({ style, link }) => {
  const { logo, logoHeight } = teiBranding()
  const image = <img src={logo} alt='Logo' height={logoHeight} />

  return (
    <div className={classes.TEIDLogo} style={style}>
      {link ? (
        <Link className={classes.Link} to={link}>
          {image}
        </Link>
      ) : (
        image
      )}
    </div>
  )
}

TEIDLogo.propTypes = {
  style: PropTypes.object,
  link: PropTypes.string,
}

TEIDLogo.defaultProps = {
  style: {},
}

export default TEIDLogo
